import React from "react";
import CustomTypography from "../../typography";
import { InfoBoxProps } from "../types";

export default function InfoBoxTitle(props: InfoBoxProps): React.JSX.Element {
  const { children } = props;
  return (
    <CustomTypography variant="body1" className="scd-infobox-title">
      {children}
    </CustomTypography>
  );
}
